import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import ArticleCard from '../components/ArticleCard';
import SectionBlock from '../components/SectionBlock';
import Sidebar from '../components/Sidebar';
import AdBox from '../components/AdBox';
import { fetchArticles, fetchWeather, fetchTrending } from '../services/newsService';
import { AD_SLOTS } from '../mock/mock';

export default function Home() {
  const [sections, setSections] = useState({});
  const [weather, setWeather] = useState([]);
  const [trending, setTrending] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let m = true;
    const cats = ['headlines', 'politics', 'sport', 'financials', 'fashion'];
    Promise.all([
      ...cats.map((c) => fetchArticles(c)),
      fetchWeather(),
      fetchTrending(),
    ]).then((res) => {
      if (!m) return;
      const map = {};
      cats.forEach((c, i) => { map[c] = res[i]; });
      setSections(map);
      setWeather(res[cats.length]);
      setTrending(res[cats.length + 1]);
      setLoading(false);
    });
    return () => { m = false; };
  }, []);

  const byCat = (c) => sections[c] || [];
  const headlines = byCat('headlines');
  const hero = headlines[0];
  const moreHeadlines = headlines.slice(1, 6);
  const topStories = headlines.slice(6, 9);

  if (loading) {
    return (
      <div className="max-w-[1320px] mx-auto px-4 py-16 text-center text-[#5b6b63]">
        <div className="inline-block w-8 h-8 border-2 border-[#157347] border-t-transparent rounded-full animate-spin" />
        <p className="mt-3 text-sm">Loading the latest Michigan news…</p>
      </div>
    );
  }

  return (
    <div className="max-w-[1320px] mx-auto px-4 py-6">
      {/* Hero */}
      <section className="grid grid-cols-1 lg:grid-cols-3 gap-5 fade-up">
        <div className="lg:col-span-2">{hero && <ArticleCard article={hero} variant="hero" />}</div>
        <div className="rounded-xl border border-[#e3ece7] bg-white shadow-sm overflow-hidden">
          <div className="px-4 py-3 border-b-2 border-[#157347] flex items-center justify-between">
            <span className="font-cond font-bold uppercase tracking-wider text-[#0b3d26]">Top Headlines</span>
            <Link to="/category/headlines" className="text-[#157347] hover:text-[#0f5132]"><ChevronRight className="w-5 h-5" /></Link>
          </div>
          <div className="px-4 divide-y divide-[#eef2f0]">
            {moreHeadlines.map((a) => (<ArticleCard key={a.id} article={a} variant="list" />))}
          </div>
        </div>
      </section>

      {/* Top stories strip */}
      {topStories.length > 0 && (
        <section className="mt-8 fade-up">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {topStories.map((a) => (<ArticleCard key={a.id} article={a} variant="feature" />))}
          </div>
        </section>
      )}

      {/* Inline leaderboard ad */}
      <div className="mt-8">
        <AdBox size={AD_SLOTS.inline.size} label={AD_SLOTS.inline.label} note={AD_SLOTS.inline.note} height={110} />
      </div>

      {/* Main grid + sidebar */}
      <div className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 space-y-10">
          <SectionBlock slug="politics" articles={byCat('politics')} />
          <SectionBlock slug="sport" articles={byCat('sport')} />
          <div className="rounded-xl overflow-hidden">
            <AdBox size={AD_SLOTS.inline.size} label={AD_SLOTS.inline.label} note="Sponsored placement" height={110} />
          </div>
          <SectionBlock slug="financials" articles={byCat('financials')} />
          <SectionBlock slug="fashion" articles={byCat('fashion')} />
        </div>
        <div className="lg:col-span-1">
          <Sidebar weather={weather} trending={trending} ads={AD_SLOTS.sidebar} />
        </div>
      </div>
    </div>
  );
}
